import { Component, OnInit } from '@angular/core';
import { LevelService } from 'src/app/services/lobby/level.service';
import { Navigator } from '../../menu/navigator';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-navbar-level-avatar',
  templateUrl: './navbar-level-avatar.component.html',
  styleUrls: ['./navbar-level-avatar.component.scss'],
})
export class NavbarLevelandAvatarComponent implements OnInit {

  public customer: CustomerModel;
  protected progress: number = 0;
  protected currentLevel: number;
  protected isLoggedIn: boolean = false;
  protected isMobile: boolean = false;
  constructor(
    public platform: Platform,
    private readonly levelService: LevelService,
    private readonly navigator: Navigator,
    private readonly userSessionService: UserSessionService,
  ) {
  }

  ngOnInit() {
    this.isUserLoggedIn();
    this.isMobile = this.platform.is("mobile");
  }

  protected isUserLoggedIn() {
    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
        this.levelService.getInitialLevel();

        this.isLoggedIn = true;
        this.getLevel();
        this.getProgress();
      } else {
        this.isLoggedIn = false;
      }
    });
  }

  private getLevel(): any {
    this.levelService.level$.subscribe((res) => {
      if (res) this.currentLevel = res;
    });
  }

  private getProgress(): any {
    this.levelService.progress$.subscribe((res) => {
      if (res) this.progress = res;
    });
  }

  public navigateTo(page: string, customModalClass?: string, animated?: boolean): any {
    return this.navigator.navigateTo(page, { customModalClass: customModalClass, animated: animated });
  }

}
